import { useQuery } from '@tanstack/react-query';
import * as actions from '@actions';
import { useDispatch } from 'react-redux';
import { Appointment } from 'vl-common/src/schemas/shared';

export const useTelValidation = (appointment: Appointment) => {
  const dispatch = useDispatch();

  const { data: isPrimaryTelValid } = useQuery({
    queryKey: ['isTelValid', appointment?.patient_tel_mobile_no],
    queryFn: async () => {
      try {
        if (appointment?.patient_tel_mobile_no) {
          const res = await dispatch(actions.getIsTelValid(appointment?.patient_tel_mobile_no));
          return res?.valid;
        }
        return false;
      } catch (error) {
        console.error('Primary tel validation failed', error);
        // return true to ignore failed validation
        return true;
      }
    },
    placeholderData: true,
    enabled: !!appointment?.patient_tel_mobile_no,
    staleTime: Infinity,
    gcTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false
  });

  const { data: isSecondaryTelValid } = useQuery({
    queryKey: ['isTelValid', appointment?.patient_tel_other_no],
    queryFn: async () => {
      try {
        if (appointment?.patient_tel_other_no) {
          const res = await dispatch(actions.getIsTelValid(appointment?.patient_tel_other_no));
          return res?.valid;
        }
        return false;
      } catch (error) {
        console.error('Secondary tel validation failed', error);
        // return true to ignore failed validation
        return true;
      }
    },
    placeholderData: true,
    enabled: !!appointment?.patient_tel_other_no,
    staleTime: Infinity,
    gcTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false
  });

  return { isPrimaryTelValid, isSecondaryTelValid };
};
